import React from "react";

export const ZONES = ["Ristorante", "Sabbia"];

/** Zona pasto: due opzioni affiancate, touch-friendly (iPad first). */
export default function ZonePicker({ value, onChange, size = "lg", testid = "booking-zone" }) {
  const h = size === "lg" ? "h-14 text-base tracking-[0.12em]" : "h-10 px-1 text-[11px] sm:text-sm tracking-normal sm:tracking-wide";
  return (
    <div className="grid grid-cols-2 gap-2" role="radiogroup" aria-label="Zona" data-testid={testid}>
      {ZONES.map((z) => {
        const on = value === z;
        return (
          <button key={z} type="button" role="radio" aria-checked={on} onClick={() => onChange(z)}
                  data-testid={`${testid}-${z.toLowerCase()}`}
                  className={`${h} rounded-xl border font-semibold uppercase transition-colors active:scale-[0.99] ${
                    on ? "bg-ink-900 text-white border-ink-900" : "bg-white text-ink-900 border-sand-300 hover:border-bronze-400"}`}>
            {z}
          </button>
        );
      })}
    </div>
  );
}
